import { render, staticRenderFns } from "./schoolProfile.vue?vue&type=template&id=1cb70bca&scoped=true"
import script from "./schoolProfile.vue?vue&type=script&lang=js"
export * from "./schoolProfile.vue?vue&type=script&lang=js"
import style0 from "./schoolProfile.vue?vue&type=style&index=0&id=1cb70bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb70bca",
  null
  
)

export default component.exports